module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_nordland_neg.1e822c45.pdf";